<template>
  <div>
    <b-alert
      v-for="alert in alerts"
      :key="alert.id"
      variant="danger"
      show
      dismissible
    >
      {{ alert.content }}
    </b-alert>
  </div>
</template>

<script>
import alertNoteServer from "../../server/eocNote";
export default {
  name: "EocViewSummaryAlerts",
  props: ["eoc"],
  data() {
    return {
      alerts: []
    };
  },
  mounted() {
    this.fetchAlerts();
  },
  methods: {
    async fetchAlerts() {
      const alertsNotes = await alertNoteServer.query(this.eoc.id);
      this.alerts = alertsNotes.filter(u => u.status == "Enabled");
    }
  }
};
</script>
